import { render, staticRenderFns } from "./ReferralSharedFields.vue?vue&type=template&id=155d60f2&"
import script from "./ReferralSharedFields.vue?vue&type=script&lang=js&"
export * from "./ReferralSharedFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports